import { tens, units, scales } from "./VMConstants";

// Indian scales (least-significant first, aligned with chunk indices)
const indianScales = ['', 'Thousand', 'Lakh', 'Crore', 'Arab', 'Kharab'];

/**
 * Split numeric string into 3-digit chunks (least-significant first)
 * e.g. '1234567' -> ['567','234','1']
 */
const chunkNumberIntl = (str) => {
  let start = str.length;
  const chunks = [];
  while (start > 0) {
    const end = start;
    start = Math.max(0, start - 3);
    chunks.push(str.slice(start, end));
  }
  return chunks;
};

/**
 * Split numeric string into Indian grouping:
 * last 3 digits, then groups of 2 digits (least-significant first)
 * e.g. '12345678' -> ['678','345','12']
 */
const chunkNumberIndia = (str) => {
  if (str.length <= 3) return [str];
  const chunks = [];
  // last 3
  chunks.push(str.slice(-3));
  let rest = str.slice(0, -3);
  while (rest.length > 0) {
    const len = rest.length;
    const start = Math.max(0, len - 2);
    chunks.push(rest.slice(start, len));
    rest = rest.slice(0, start);
  }
  return chunks;
};

// Convert a number to words
const convertToWords = (countryCode, number, join = 'and') => {
    // Normalize inputs
    if (number === null || number === undefined || number === '') return '';
    const stringNumber = String(number).trim();

    // If the number is 0, return 'Zero'
    if (/^0+$/.test(stringNumber)) {
        return 'Zero';
    }

    // Number upto 99 (0-99)
    const asNumber = Number(stringNumber);
    if (!Number.isNaN(asNumber) && asNumber < 100) {
        if (asNumber < 20) {
            return units[asNumber];
        }
        return tens[Math.floor(asNumber / 10)] + (asNumber % 10 ? '-' + units[asNumber % 10] : '');
    }

    /* choose grouping & scales based on countryCode */
    const useIndia = String(countryCode) === '91' || String(countryCode).toUpperCase() === 'IN';
    const chosenScales = useIndia ? indianScales : scales;
    const chunker = useIndia ? chunkNumberIndia : chunkNumberIntl;

    /* Split the number into chunks using chosen chunker */
    // let start = stringNumber.length;
    const chunks = chunker(stringNumber);

    /* Check if the number is greater than the scales */
    const chunksLen = chunks.length;
    if (chunksLen > chosenScales.length) {
        // number too large for available scales
        return '';
    }

    // Convert each chunk to words
    const wordsArr = [];
    for (let i = 0; i < chunksLen; i++) {
        const chunkStr = chunks[i];
        const chunk = parseInt(chunkStr, 10);

        if (chunk) {
            // Split chunk into array of individual integers (units,tens,hundreds)
            const ints = chunkStr.split('').reverse().map(Number);

            // If tens integer is 1, i.e. 10..19, then add 10 to units integer
            if (ints[1] === 1) {
                ints[0] += 10;
            }

            // Add scale word if chunk is not zero and array item exists
            let word;
            if ((word = chosenScales[i])) {
                // push scale AFTER the chunk words in the original version,
                // but to keep same ordering as original function (which reversed at end),
                // push here — final reverse will put scales in correct positions.
                wordsArr.push(word);
            }

            // Add unit word if array item exists
            if ((word = units[ints[0]])) {
                wordsArr.push(word);
            }

            // Add tens word if array item exists
            if ((word = tens[ints[1]])) {
                wordsArr.push(word);
            }

            // Add 'join' value after the hundreds place
            if (ints[0] || ints[1]) {
                if (ints[2] || (!i && chunksLen)) {
                    wordsArr.push(join);
                }
            }

            // Add hundreds word if array item exists
            if ((word = units[ints[2]])) {
                wordsArr.push(word + ' Hundred');
            }
        }
    }

    return wordsArr.reverse().join(' ');
};

export { convertToWords };
